module.exports = __webpack_public_path__ + "assets/open-email.9cf727f5.svg";